@if (params.data.theft_count > 0) {
  <app-pan-incident-status-chip status="has-incident" [count]="params.data.theft_count"></app-pan-incident-status-chip>
} @else {
  <app-pan-incident-status-chip status="no-incident" [count]="params.data.theft_count"></app-pan-incident-status-chip>
}
